import { render, staticRenderFns } from "./TheMoreDetailsBtnPush.vue?vue&type=template&id=2ec28a1c&scoped=true"
import script from "./TheMoreDetailsBtnPush.vue?vue&type=script&lang=ts"
export * from "./TheMoreDetailsBtnPush.vue?vue&type=script&lang=ts"
import style0 from "./TheMoreDetailsBtnPush.vue?vue&type=style&index=0&id=2ec28a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec28a1c",
  null
  
)

export default component.exports